import { useState, createContext, useEffect } from 'react';

export const TheOrderContext = createContext();

export const TheOrderContextProvider = (props) => {
    // אתחול ההזמנה עם items ומאפיין counter
    const [theOrder, setTheOrder] = useState({ items: [], counter: 0 });

    useEffect(() => {
        let ordOn = JSON.parse(sessionStorage.getItem("NapShCrt"));
        if (ordOn) {
            setTheOrder(ordOn);
        }
    }, []);

    useEffect(() => {
        sessionStorage.setItem("NapShCrt", JSON.stringify(theOrder));
    }, [theOrder]);

    // מוסיף מוצר חדש להזמנה
    const addToTheOrder = (item) => {
        let tempOrd = { ...theOrder };

        // שימוש ב-counter מתוך ההזמנה
        const newItem = {
            ...item,
            innerIndx: tempOrd.counter,
            mount: item.mount ? item.mount : 1
        };

        tempOrd.items.push(newItem);
        // עדכון ה-counter
        tempOrd.counter = tempOrd.counter + 1;
        setTheOrder(tempOrd);
    };

    const updateTheOrd = (ordToUp) => {
        setTheOrder(ordToUp);
    };

    return (
        <TheOrderContext.Provider value={{ theOrder, setTheOrder, addToTheOrder, updateTheOrd }}>
            {props.children}
        </TheOrderContext.Provider>
    );
};
